import { InputLabel, styled } from '@mui/material';
import React, { useRef, useState } from 'react';
import { InputFieldProps } from '../../common/Inputs/Input';
import { InputWrapper } from '../../common/Inputs/InputWrapper';

const AttachStyled = styled(InputLabel)<{ bgcolor?: string }>`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, bgcolor }) => bgcolor || theme.color.lightGrey};
  padding: 4px 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.common.black};
  border-radius: 10px;
  margin: 4% 0;
`;

interface AttachFileProps extends InputFieldProps {
  bgcolor?: string;
}

export const DataMigrationAttachFile: React.FC<AttachFileProps> = ({
  children,
  info,
  id,
  width,
  alignitems,
  padding,
  bgcolor,
  margin,
  onChange,
  ...rest
}) => {
  const ref: any = useRef();
  return (
    <InputWrapper width={width} alignitems={alignitems} info={info}>
      <AttachStyled htmlFor={id} bgcolor={bgcolor}>
        {ref?.current?.files[0]?.name || children}
      </AttachStyled>
      <input
        type="file"
        id={id}
        accept=".csv"
        {...rest}
        style={{ display: 'none' }}
        onChange={onChange}
        ref={ref}
      />
    </InputWrapper>
  );
};
